import { useNavigate } from "react-router-dom";

const SingleCard = ({ item }) => {
  const {
    iconImg,
    iconBgColor,
    monthBgColor,
    title,
    count,
    days,
    month,
    dots,
    linkTo,
  } = item;

  const navigate = useNavigate();

  return (
    <div className="w-full h-full p-[15px] rounded-[8px] bg-white flex-1">
      <div>
        {/* Top */}
        <div className="flex justify-between text-[1.8rem]">
          <div
            className={`${iconBgColor} flex w-[40px] h-[40px] items-center justify-center rounded-full`}
          >
            <img src={iconImg} alt="icon" />
          </div>

          <span
            className="text-gray-500 -mt-[15px] cursor-pointer"
            onClick={() => linkTo && navigate(linkTo)}
          >
            <i className={dots}></i>
          </span>
        </div>

        {/* Bottom */}
        <div className="flex items-center justify-between">
          <div>
            <h5 className="text-[12px] font-medium mt-4 text-[var(--color-text-dark)]">
              {title}
            </h5>

            <h2 className="font-semibold text-[26px]">
              {count}
            </h2>

            <p className="font-medium text-[10px] pt-4 mb-0">
              {days}
            </p>
          </div>

          {month && (
            <div className={`${monthBgColor} rounded-[10px]`}>
              <span className="flex px-[8px] py-[4px] text-center whitespace-nowrap text-[9px] font-medium">
                {month}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleCard;